// extracted by mini-css-extract-plugin
var _1 = "JW91bysY2P";
var _2 = "pWvJjM4Zn9";
var _3 = "Af9rzrfBct";
export { _1 as "messageArea", _2 as "messageText", _3 as "textArea" }
